<template>
  <div class="team-style">
    <div style="margin-bottom:0.8rem">
      <el-button @click="addStyle" size="small" type="success" icon="el-icon-plus">添加风采</el-button>
      <el-button :loading="styleLoading" size="small" @click="saveStyle" type="primary">保存</el-button>
    </div>
    <div v-for="(msg,index) in styleDate" :key="index" class="introduction-box">
      <div class="team-style-box">
        <span class="trend-title">活动名称</span>
        <el-input show-word-limit type="text" maxlength="30" placeholder="请输入" v-model="msg.activeName"></el-input>
        <el-button @click="removeStyle(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
      <div class="team-style-box">
        <span class="trend-title">照片</span>
        <div style="display:inline-block;">
          <el-upload 
            class="avatar-uploader"  
            :http-request="(e)=>{uploadfile(e,index)}" 
            action="#" 
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <img v-if="msg.activeImg" :src="msg.activeImg" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="team-style-box">
        <span class="trend-title">活动介绍</span>
        <el-input maxlength="500" show-word-limit :rows="4" type="textarea" placeholder="请输入" v-model="msg.remark"></el-input>
        
      </div>
    </div>
    <!-- <div class="last-save">
      
    </div> -->
  </div>
</template>

<script>
import api from '@/apis/sale/sale'
import upapi from '@/apis/upload'
export default {
  data(){
    return{
      styleLoading:false,//加载状态
      styleDate:[
        {activeName:'',activeImg:'',remark:''}
      ]
    }
  },
  mounted(){
    this.getStyle()
  },
  methods:{
    //保存数据
    saveStyle(){
      this.styleLoading = true;
      api.saveActive(this.styleDate).then(res=>{
        if(res.code==10000){
          this.styleLoading = false;
          this.getStyle()
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message);
          this.styleLoading = false;
          return;
        }
      })
    },
    //获取数据
    getStyle(){
      api.getActive().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.styleDate = res.data.list
          }
        }
      })
    },
    //删除一行人员数据
    removeStyle(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delActive([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getStyle()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.styleDate.splice(index,1)
      }
    },
    //图片上传成功的回调函数
    uploadfile(val,i) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.styleDate[i].activeImg = res.data
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },
    //判断上传文件格式是否合法
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    //添加一行人员数据
    addStyle(){
      this.styleDate.unshift({activeName:'',activeImg:'',remark:''})
    },
  }
}
</script>
<style lang="less" scoped>
.team-style{ padding-top: 10px;
  .introduction-box{display:inline-block; border: #3570ff solid 1px; position: relative; width: 30%; padding:1rem; margin-right:1rem; margin-bottom: 1rem; position: relative;
    .team-style-box{display:flex; flex-direction: row; margin-bottom: 15px;
      .trend-title{ width:8rem; flex-shrink: 0;}
      .el-input{ width: 100%;}
      .avatar,.avatar-uploader{ width: 6rem; height: 7rem; border: #3570ff solid 1px; vertical-align: top;}
      .avatar-uploader{ color: #fff; text-align:center; line-height: 7rem; font-size: 2rem; vertical-align: top;}
    }
  }
}
</style>